'use strict';

var parser = require('./pegjs/parser');
var RsqlParserService = function RsqlParserService() {
  function parse(input) {
    return parser.parse(input);
  }
  return {
    parse: parse
  };
};
RsqlParserService.$inject = [];
module.exports = RsqlParserService;